import { axiosApiCallWithToken } from "../axios/customInstance";

/**
 * Get all patients for admin management
 */
export const getAllPatientsForAdmin = async () => {
    const url = "/admin/patients";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

/**
 * Get total count of all patients (active + inactive)
 */
export const getTotalPatientsCountForAdmin = async () => {
    const url = "/admin/patients/count";

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

/**
 * Deactivate a patient account
 */
export const deactivatePatient = async (userId) => {
    const url = `/admin/patients/${userId}/deactivate`;

    try {
        return await axiosApiCallWithToken.put(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};

/**
 * Reactivate a patient account
 */
export const reactivatePatient = async (userId) => {
    const url = `/admin/patients/${userId}/reactivate`;

    try {
        return await axiosApiCallWithToken.put(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};